import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Import assets
import PortalLogo from 'assets/icons/nexgentv_go.svg';

// Import components
import Nav from 'components/layout/nav/Nav';
import MobileNav from 'components/layout/mobile_nav/MobileNav';

// Import styles
import { HeaderStyled, Wrapper, Logo, Image } from './styles';

// Import helpers
import { useAuth, useIsMobile } from 'components/utilities';
import { sendHeaderMenuEvent } from 'helpers/tracking';
import { isRetail } from 'helpers/operators';

// Import variables
import { MAIN_PATHS } from 'components/routes/app_routes/paths';
import { NAV_EXCLUDED_PATHS } from './variables';
import { CONFIGURATOR_PATHS } from 'components/routes/configurator/routes';

const { HOME } = MAIN_PATHS;

const Header = React.memo(() => {
	const { pathname } = useLocation();
	const { isAuth } = useAuth();
	const isMobile = useIsMobile();

	if (pathname === CONFIGURATOR_PATHS.OFFER) return null;

	const showNav = isRetail || isAuth;
	const isNavAllowedPath = !NAV_EXCLUDED_PATHS.includes(pathname);

	return (
		<HeaderStyled isShadow={isNavAllowedPath}>
			<Wrapper>
				<Logo>
					<Link to={HOME} onClick={sendHeaderMenuEvent.bind(null, { url: HOME, text: 'Logo' })}>
						<Image src={PortalLogo} alt="Logo" />
					</Link>
				</Logo>
				{showNav && isNavAllowedPath && <>{isMobile ? <MobileNav /> : <Nav />}</>}
			</Wrapper>
		</HeaderStyled>
	);
});

export default Header;
